import { useLDClient } from 'launchdarkly-react-client-sdk';

import {
  type AlertsToShow,
  computeAlertsToShow,
  useAlertClock,
} from '@cfa/pathway-fe-shared/alerts';

import { useAuth } from '@/hooks/useAuth';
import { useFlags } from '@/hooks/useFlags';

/**
 * Eligible `web-alert-banner` entries for the current user, split into
 * banners and message blocks. Dismissals are not applied here.
 */
export const useAlertsToShow = (): AlertsToShow => {
  const { data: auth } = useAuth();
  const { webAlertBanner } = useFlags();
  const now = useAlertClock(webAlertBanner);
  const ldClient = useLDClient();

  const complianceDetail = ldClient?.variationDetail(
    'xp-compliance-plans',
    false,
  );

  return computeAlertsToShow(
    webAlertBanner,
    {
      isLeaderOrOperator:
        (auth?.allLocationsWithAtLeastLeaderRoles ?? []).length > 0,
      hasComplianceEnabled:
        auth?.features.settings?.compliance?.enabled === true,
      hasXpCompliancePlans: complianceDetail?.value === true,
      isInCompliancePhaseSegment:
        complianceDetail?.reason?.kind === 'RULE_MATCH',
      isInChainWideRollout: complianceDetail?.reason?.kind === 'FALLTHROUGH',
    },
    now,
  );
};
